module.exports = __webpack_public_path__ + "static/media/envelope.39c094f9.svg";